import React, { Component } from 'react';
import i18n from 'react-intl-universal';
import { darken } from 'polished';

import {
  withStyles,
  createMuiTheme,
  MuiThemeProvider
} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import styles from './styles';
import logo from '../../../assets/images/logo.svg';
import theme from '../../../setupTheme';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

const darkenedTheme = createMuiTheme({
  palette: {
    primary: {
      main: theme.palette.primary.main,
      contrastText: theme.palette.primary.contrastText
    },
    secondary: {
      main: darken(0.2, theme.palette.secondary.main),
      contrastText: theme.palette.secondary.contrastText
    }
  }
});

class AuthTemplate extends Component {
  render() {
    const { classes, onEnter } = this.props;
    return (
      <MuiThemeProvider theme={darkenedTheme}>
        <div tabIndex="0" onKeyPress={onEnter} className={classes.root}>
          <Hidden smDown implementation="css">
            <AppBar position="static" className={classes.appbar}>
              <Toolbar />
            </AppBar>
          </Hidden>
          <Grid container className={classes.grid}>
            <Grid item xs={3} sm={4} md={4} className={classes.paperWrapper}>
              <Paper className={classes.paper}>
                <div className={classes.logoWrapper}>
                  <img
                    className={classes.logo}
                    src={logo}
                    alt={i18n.get('app.siteName')}
                  />
                </div>
                <div className={classes.content}>{this.props.children}</div>
              </Paper>
            </Grid>
          </Grid>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(AuthTemplate);
